<template>
  <div id="sidebar" class="sidebar">
    <div data-scrollbar="true" data-height="100%">
      <ul class="nav">
        <li class="nav-header">Navigation</li>
        <li v-for="(item, index) in navItems">
            <a :href="item.url">
              <i :class="item.icon"></i>
              <span> {{ item.name }} </span>
            </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
export default {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>
<style lang="css">
.nav-link {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/admin/components/Sidebar/Sidebar.vue